/** [C33] Error helpers of the Store container (re-exports of app/errors plus a typed guard for API refusals). */
import { isApiClientError, type ApiClientError } from "../../api/client.js";

export { engineErrors, errorMessage, isSessionLost } from "../../app/errors.js";

export function isApiClientErrorLike(e: unknown): e is ApiClientError {
  return isApiClientError(e);
}
